import React from "react";

const ViewReview = () => {
  return <div>ViewLead</div>;
};

export default ViewReview;
